import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/pdf-viewer-v2.0.0'

export default reactNode(
	'PdfViewer',
	{
		'v2.0.0': v200,
	},
	{ docs: '' }
)
